import { createFileRoute } from '@tanstack/react-router';
import { SellPage } from '@/features/inventory/pages/sell-page';

export const Route = createFileRoute('/_app/inventory/sell')({ component: SellPage });
